export const vehicleLengthOptions = [
  { name: { v_type: "Vehicle Type", v_length: "Typical Length" }, value: "", isDisabled: true },
  { name: { v_type: "Passenger Car (Sedan/SUV)", v_length: "15 ft (4.6 m)" }, value: 15 },
  { name: { v_type: "Pickup Truck", v_length: "20 ft (6.1 m)" }, value: 20 },
  { name: { v_type: "Pickup + Trailer", v_length: "50 ft (15.2 m)" }, value: 50 },
  { name: { v_type: "Truck + Gooseneck", v_length: "65 ft (19.8 m)" }, value: 65 },
  { name: { v_type: "Box Truck (Small)", v_length: "16 ft (4.9 m)" }, value: 16 },
  { name: { v_type: "Box Truck (Medium)", v_length: "26 ft (7.9 m)" }, value: 26 },
  { name: { v_type: "Step Van (FedEx/U-Haul)", v_length: "20 ft (6.1 m)" }, value: 20 },
  { name: { v_type: "Truck Only (Day Cab)", v_length: "23 ft (7.0 m)" }, value: 23 },
  { name: { v_type: "Dry Van Trailer", v_length: "53 ft (16.15 m)" }, value: 53 },
  { name: { v_type: "Truck + Trailer (Semi)", v_length: "70 ft (21.3 m)" }, value: 70 },
  { name: { v_type: "Gooseneck/Flatbed Trailer", v_length: "40 ft (12.2 m)" }, value: 40 },
];

export const monthOptions = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" }
];

export const statusOptions = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "UPCOMING", value: "UPCOMING" },
  { label: "EXPIRING_SOON", value: "EXPIRING_SOON" },
  { label: "EXPIRED", value: "EXPIRED" },
];

export const NOTIFICATION_TYPE = {
  // Critical Alerts
  DRIVER_ENTERED: "DRIVER_ENTERED",
  DRIVER_LEFT: "DRIVER_LEFT",
  // Operational Alerts
  BOOKING_EXPIRING: "BOOKING_EXPIRING",
  EXPIRATION_REMINDER: "EXPIRATION_REMINDER",
  RESERVATION_STARTED: "RESERVATION_STARTED",
  RESERVATION_ENDED: "RESERVATION_ENDED",
  // Info Alerts
  BOOKING_CREATED: "BOOKING_CREATED",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  SYSTEM_NOTIFICATION: "SYSTEM_NOTIFICATION"
};